/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconActivityHeartbeat = createReactComponent(
  "activity-heartbeat",
  "IconActivityHeartbeat",
  [["path", { d: "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5", key: "svg-0" }]]
);

export { IconActivityHeartbeat as default };
//# sourceMappingURL=IconActivityHeartbeat.js.map
